export const GET_USER = 'GET_USER'
export const GET_USER_ERR = 'GET_USER_ERR'

export const RESET_GET_USER = 'RESET_GET_USER'
